import React from 'react';
import { 
  Network, 
  Award, 
  Layers, 
  MessageSquare, 
  CheckCircle, 
  Handshake 
} from 'lucide-react';
import { whyFHI } from '@/data/mock';

const iconMap = {
  Network: Network,
  Award: Award,
  Layers: Layers,
  MessageSquare: MessageSquare,
  CheckCircle: CheckCircle,
  Handshake: Handshake
};

const WhyFHISection = () => {
  return (
    <section className="py-20 md:py-32 bg-accent/20">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-4">
            Why Work With FHI
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Your trusted partner for Indian trade and sourcing
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {whyFHI.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="group p-6 rounded-xl bg-background/50 backdrop-blur-sm border border-border/50 hover:border-border hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-lg bg-foreground/5 dark:bg-amber-600/20 group-hover:bg-foreground/10 dark:group-hover:bg-amber-600/30 transition-colors">
                  <IconComponent className="h-6 w-6 dark:text-amber-500" />
                </div>
                <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyFHISection;
